/**
 * Teilnehmerfarben des Playtest-Bretts (Geometrie: boardGeometry.js). Die Werte stehen als
 * `--playtest-player-1` … `-4` in `theme.css`; hier nur die Zuordnung Sitzplatz → Token.
 */

const SEAT_COUNT = 4;

/**
 * Farbe des Sitzplatzes als CSS-Wert (`var(--playtest-player-n)`), für Inline-Stile und
 * CSS-Variablen; unbekannte Plätze fallen auf Platz 0.
 * @param {number} position - Sitzplatz 0–3
 */
export function getPlayerColor(position) {
  const seat = Number.isInteger(position) && position >= 0 && position < SEAT_COUNT ? position : 0;
  return `var(--playtest-player-${seat + 1})`;
}
